<template>
  <div id="app" class="container-fluid">
    <!-- Header (UNCHANGED) -->
    <full_dermatology_head :visit_id="visit_id" />

    <!-- Main Content -->
    <div v-if="loading">
      <loader />
    </div>
    <div v-if="!loading" class="main-content">
      <div class="card procedures-card">
        <div class="card-header procedures-header">
          <div>
            <h3 class="mb-1">
              <i class="fas fa-notes-medical"></i>
              Procedures
            </h3>
            <small class="text-muted">
              Procedures conducted and scheduled for this patient
            </small>
          </div>

          <button class="btn btn-primary" @click="showCreatePatientService">
            <i class="fas fa-plus"></i> Add Procedure
          </button>
        </div>

        <div class="card-body">
          <div class="table-responsive">
            <table class="table procedures-table">
              <thead>
                <tr>
                  <th scope="col">Service Ref.Number</th>
                  <th scope="col">Service Name</th>
                  <th scope="col">Affected Site</th>
                  <th scope="col">Status</th>
                  <th class="text-end" scope="col">Actions</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="service in services" :key="service.id">
                  <th scope="row">{{ service.id }}</th>
                  <td style="color: black">{{ service.service_name }}</td>
                  <td style="color: black">
                    <span v-if="service.body_part != null">
                      {{ service.body_part }}
                    </span>
                    <span v-else> --- </span>
                  </td>
                  <td>
                    {{
                      service.attended == "0" || service.attended == null
                        ? "Pending..."
                        : service.attended == "1"
                        ? "Attended"
                        : "--"
                    }}
                  </td>
                  <td class="text-end">
                    <span
                      v-if="
                        open_service(
                          service.is_invoice,
                          service.is_paid,
                          cash_bills_behavior
                        )
                      "
                    >
                      <button
                        v-if="service.attended != '1'"
                        @click="showCreateNursingModal(service.id)"
                      >
                        Conduct
                      </button>
                      .
                    </span>

                    <span
                      v-if="
                        !open_service(
                          service.is_invoice,
                          service.is_paid,
                          cash_bills_behavior
                        )
                      "
                      style="
                        color: black;
                        background-color: pink;
                        padding: 1px;
                        margin: 2px;
                      "
                    >
                      !! Pending Payment !!
                    </span>

                    <button
                      style="background-color: red; color: white"
                      v-if="service.attended != '1'"
                      @click="removeService(service.id)"
                    >
                      Delete Service</button
                    >.
                    <button
                      v-if="service.attended == '1'"
                      @click="triggerShowResultModal(service.id)"
                    >
                      View
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <AddNursingCareModal
    v-if="show_add_nursing_modal"
    @hide-create-nursing-model="hideCreateNursingModal"
    :service_id="current_service"
  />

  <CreateServiceModal
    v-if="showAddServiceModal"
    :visitId="visit_id"
    @close-add-service-modal="showAddServiceModal = false"
  />

  <vew_nursing_result_modal
    v-if="showResultModal"
    :service_id="current_service"
    @hide-view-result-modal="showResultModal = false"
  />
</template>

<script>
import full_dermatology_head from "./full_dermatology_head.vue";
import { generalApiRequest } from "../../../api/apiIndex.js";
// import CreateServiceModal from "../../visits_management/add_patient_service_modal.vue";
import CreateServiceModal from "./add_dermatology_procedures_modal.vue";
import AddNursingCareModal from "../../visits_management/nursing/conduct_nursing.vue";
import vew_nursing_result_modal from "../../visits_management/nursing/vew_nursing_result_modal.vue";
import { get_setting } from "../../../settings/get_setting.js";
import { open_service } from "../../../settings/get_setting.js";

import loader from "../../special_clinics/dialysis/loader.vue";

export default {
  name: "PatientProcedures",
  components: {
    full_dermatology_head,
    AddNursingCareModal,
    // PatientInfo,
    CreateServiceModal,
    vew_nursing_result_modal,
    loader,
  },
  data() {
    return {
      visit_id: this.$route.params.visit_id,
      procedures: [],
      showResultModal: false,
      show_add_nursing_modal: false,
      showAddServiceModal: false,
      current_service: "",
      services: [],
      patient_id: null,
      cash_bills_behavior: 0,
      loading: false,
    };
  },

  methods: {
    open_service,
    navigate_loc(route) {
      window.location.href = route;
    },
    showCreateNursingModal(service_id) {
      this.current_service = service_id;
      this.show_add_nursing_modal = true;
    },
    hideCreateNursingModal() {
      this.current_service = "";
      this.show_add_nursing_modal = false;
    },
    triggerShowResultModal(tid) {
      // console.log(tid);

      this.current_service = tid;
      this.showResultModal = true;
    },

    async fetchServicesForVisit() {
      const url = `services/for-visit/${this.visit_id}` + "/9";
      try {
        const res = await generalApiRequest(url, "GET", {}, 1);
        console.log(res);

        this.services = res.data;
        const payment_setting = await get_setting("cash_bills_behavior");
        this.cash_bills_behavior = payment_setting.setting_value;
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    },

    async removeService(serviceId) {
      const url = "services/delete/" + serviceId;
      const res = await generalApiRequest(url, "GET", {}, 1);
      if (res) {
        location.reload();
      }
    },

    async mountPastRecords() {
      const url = "get_all_visits_dates";
      const res = await generalApiRequest(
        url,
        "GET",
        { visit_id: this.visit_id },
        1
      );
      this.past_records = res.data;
      if (res.data.length > 0) {
        this.patient_id = res.data[0].patient_id;
      }
    },

    handleShowConductModal(serviceId) {
      this.current_service = serviceId;
      this.show_add_nursing_modal = true;
    },

    hideConductModal() {
      this.show_add_nursing_modal = false;
    },

    showCreatePatientService() {
      this.showAddServiceModal = true;
    },
    getStatusClass(status) {
      return {
        Scheduled: "status-scheduled",
        Ongoing: "status-ongoing",
        Completed: "status-completed",
        Cancelled: "status-cancelled",
      }[status];
    },
  },
  mounted() {
    this.mountPastRecords();
    this.fetchServicesForVisit();
  },
};
</script>

<style scoped>
/* Card */
.procedures-card {
  margin-top: 20px;
  border-radius: 10px;
  border: 1px solid #dee2e6;
}

/* Header */
.procedures-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: linear-gradient(135deg, #f8f9fa, #eef1f4);
  padding: 18px 22px;
  border-bottom: 1px solid #dee2e6;
}

.procedures-header h3 {
  margin: 0;
  font-size: 20px;
  color: #343a40;
}

/* Table */
.procedures-table {
  font-size: 0.95rem;
}

.procedures-table thead th {
  background: #f1f3f5;
  font-weight: 600;
  color: #495057;
  border-bottom: 2px solid #dee2e6;
}

.procedures-table tbody tr {
  transition: background 0.2s ease;
}

.procedures-table tbody tr:hover {
  background: #f8f9fa;
}

/* Status badges */
.status-badge {
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

.status-scheduled {
  background: #e7f1ff;
  color: #0d6efd;
}

.status-ongoing {
  background: #fff3cd;
  color: #856404;
}

.status-completed {
  background: #d4edda;
  color: #155724;
}

.status-cancelled {
  background: #f8d7da;
  color: #721c24;
}

/* Buttons */
.btn-sm {
  padding: 4px 8px;
}

/* Responsive */
@media (max-width: 768px) {
  .procedures-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }
}
</style>
